import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const AgriErpLogo = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        // width="100%"
        // viewBox="0 0 500 500"
        enable-background="new 0 0 500 500"
      >
        <path
          // fill="#FEFEFE"
          opacity="1.000000"
          stroke="none"
          d="
M335.000000,501.000000 
	C223.333359,501.000000 112.166718,501.000000 1.000060,501.000000 
	C1.000040,334.333405 1.000040,167.666794 1.000020,1.000149 
	C167.666565,1.000099 334.333130,1.000099 500.999756,1.000050 
	C500.999847,167.666519 500.999847,334.333038 500.999939,500.999786 
	C445.833344,501.000000 390.666656,501.000000 335.000000,501.000000 
M463.977966,125.936440 
	C461.545166,123.236771 459.204498,120.446487 456.658661,117.858002 
	C452.513214,113.643097 450.745422,113.504181 446.791107,117.695763 
	C443.413696,121.275833 439.898834,121.879608 435.615082,119.740883 
	C433.540558,118.705154 431.396149,117.753242 429.193298,117.042595 
	C424.710297,115.596382 423.023987,112.607353 423.104950,107.977257 
	C423.209076,102.020950 422.022217,101.039215 416.110535,100.999130 
	C414.278687,100.986710 412.446686,100.994583 410.614777,100.997665 
	C403.572357,101.009514 403.192261,101.383026 402.828125,108.635269 
	C402.501404,115.142502 388.260681,123.379364 382.433960,120.400780 
	C381.712585,120.031998 381.108093,119.413109 380.492737,118.861801 
	C374.155518,113.184425 373.646057,113.197617 367.578308,119.264229 
	C366.636200,120.206184 365.678528,121.132988 364.750336,122.088440 
	C360.734680,126.222015 360.587524,128.092636 364.706635,132.032486 
	C368.033966,135.215027 368.972504,138.543808 366.948486,142.747253 
	C365.797760,145.137100 364.841125,147.626236 363.899261,150.109421 
	C362.422363,154.003143 359.662689,155.760956 355.500946,155.869003 
	C348.328125,156.055222 348.007416,156.494720 347.997559,163.749420 
	C347.995544,165.248260 347.994476,166.747101 347.997681,168.245941 
	C348.012482,175.160034 348.755524,175.927933 355.658020,176.170059 
	C362.591278,176.413269 370.563477,190.780014 367.113739,196.837036 
	C366.788940,197.407333 366.354401,197.922363 365.927063,198.425949 
	C360.258453,205.106644 360.256317,205.105225 366.369415,211.222931 
	C367.311096,212.165359 368.250305,213.110367 369.199829,214.044830 
	C373.429565,218.207458 375.187408,218.433395 379.080536,214.207489 
	C382.455963,210.543564 385.967102,210.063492 390.241089,212.098694 
	C392.487396,213.168335 394.798218,214.122711 397.135803,214.975983 
	C401.093842,216.420731 402.755096,219.243332 402.861633,223.371307 
	C403.041046,230.323456 403.803833,230.976929 410.726868,231.001999 
	C412.225677,231.007416 413.724579,231.008911 415.223389,231.001724 
	C422.089661,230.968796 422.983124,230.102722 423.169983,223.311584 
	C423.356781,216.522919 437.790039,208.306152 443.787292,211.590881 
	C444.361572,211.905411 444.850739,212.383682 445.357666,212.811676 
	C452.106079,218.508362 452.104950,218.509354 458.410034,212.204529 
	C459.116577,211.498032 459.828125,210.796570 460.533234,210.088684 
	C465.429413,205.173019 465.443420,204.148315 460.687622,199.087326 
	C455.959961,194.056290 460.545502,178.132278 467.246613,176.362396 
	C467.879456,176.195267 468.565094,176.218445 469.227661,176.174713 
	C477.971100,175.597458 477.999268,175.568604 478.002625,166.809372 
	C478.003265,165.143997 477.993652,163.478561 478.003632,161.813248 
	C478.027893,157.751038 476.263336,155.470276 471.954498,155.841446 
	C466.279602,156.330261 462.827454,153.791748 461.225739,148.367691 
	C460.570648,146.149216 459.558350,144.030060 458.630707,141.899628 
	C457.122681,138.436432 457.810913,135.611359 460.425629,132.825806 
	C462.016449,131.131088 462.889252,128.762405 463.977966,125.936440 
M114.688110,297.990265 
	C127.826996,300.891724 140.012253,299.878143 149.875015,288.867218 
	C150.451477,292.148407 150.933929,294.894409 151.414398,297.629181 
	C157.307022,297.629181 163.014465,297.629181 168.660568,297.629181 
	C168.660568,286.317108 168.660568,275.383240 168.660568,264.350525 
	C153.790146,264.350525 139.123276,264.350525 124.628754,264.350525 
	C124.628754,268.320099 124.628754,271.893707 124.628754,275.759644 
	C128.457947,275.759644 131.933411,275.759613 135.408875,275.759613 
	C138.832260,275.759613 142.255646,275.759644 146.875336,275.759644 
	C145.124481,277.840973 144.290207,279.251801 143.087677,280.191315 
	C137.129059,284.846710 125.091415,283.559998 120.154602,277.850555 
	C115.622902,272.609619 116.124565,263.472809 121.201851,258.777496 
	C126.418198,253.953598 134.591675,254.496216 139.937668,259.971069 
	C140.562943,260.611450 141.508316,261.539337 142.177902,261.443512 
	C148.862610,260.487030 155.520584,259.343658 162.186111,258.253021 
	C162.547638,257.758881 162.909164,257.264740 163.270691,256.770599 
	C160.205688,252.866547 157.733307,248.227509 153.968246,245.191635 
	C140.931595,234.679840 115.975372,236.062958 103.226212,246.912537 
	C89.416466,258.664673 88.306168,289.577271 114.688110,297.990265 
M383.083191,293.402679 
	C387.916016,299.209930 394.315094,299.939270 401.230957,299.007172 
	C411.258667,297.655701 412.109741,296.325104 408.935181,286.884247 
	C408.840759,286.603394 408.542847,286.390961 408.388733,286.205566 
	C398.708008,288.822479 400.007294,277.826416 393.854126,275.545013 
	C405.992554,269.971893 409.797577,263.131012 406.959930,253.010956 
	C404.848694,245.481537 397.690186,240.278595 387.670746,239.997147 
	C373.371185,239.595459 359.056183,239.736649 344.747650,239.678284 
	C343.638916,239.673752 342.529114,239.923660 341.473236,240.048965 
	C341.473236,259.412292 341.473236,278.493530 341.473236,297.624115 
	C349.396637,297.624115 357.082520,297.624115 365.135498,297.624115 
	C365.135498,291.313293 365.135498,285.383026 365.135498,279.540009 
	C371.737366,278.391510 376.134918,280.607574 378.752716,286.486816 
	C379.756470,288.741150 381.282837,290.762817 383.083191,293.402679 
M214.509552,288.936737 
	C221.625595,300.324371 234.885056,302.912445 245.918915,294.902222 
	C245.000290,292.018127 244.061371,289.070282 243.128204,286.140533 
	C233.204163,288.889740 234.540421,277.760925 228.431076,275.629486 
	C238.554993,270.633545 241.765182,266.906982 242.132233,260.090790 
	C242.760712,248.419418 235.387039,240.601242 222.336517,240.019943 
	C210.871979,239.509262 199.373703,239.749512 187.890228,239.673782 
	C183.970108,239.647919 180.049683,239.669678 176.235748,239.669678 
	C176.235748,259.481537 176.235748,278.672485 176.235748,297.778381 
	C184.024521,297.778381 191.460495,297.778381 199.465927,297.778381 
	C199.465927,291.531799 199.465927,285.491028 199.465927,279.651703 
	C207.560745,277.924408 211.566269,281.962402 214.509552,288.936737 
M475.144409,275.687592 
	C481.817261,269.592896 483.041260,262.001099 480.591095,253.776932 
	C478.055511,245.266159 471.292999,240.738693 463.116272,240.347427 
	C447.541016,239.602112 431.904724,240.131271 416.339478,240.131271 
	C416.339478,259.336121 416.339478,278.560059 416.339478,297.686157 
	C424.201935,297.686157 431.760498,297.686157 439.799744,297.686157 
	C439.799744,292.141754 439.799744,286.904877 439.799744,281.292389 
	C445.412231,281.292389 450.544250,281.315002 455.675995,281.286774 
	C462.425110,281.249634 468.947937,280.345947 475.144409,275.687592 
M282.039581,265.500000 
	C282.039581,276.261322 282.039581,287.022644 282.039581,297.692688 
	C300.199158,297.692688 317.764252,297.692688 335.390442,297.692688 
	C335.390442,292.449341 335.390442,287.521606 335.390442,282.052429 
	C325.093811,282.052429 315.038116,282.052429 305.128967,282.052429 
	C305.128967,279.423584 305.128967,277.346924 305.128967,274.900818 
	C314.004517,274.900818 322.590637,274.900818 331.316376,274.900818 
	C331.316376,270.404816 331.316376,266.304565 331.316376,261.748993 
	C322.509460,261.748993 313.919373,261.748993 305.128876,261.748993 
	C305.128876,259.388916 305.128876,257.491241 305.128876,255.140045 
	C315.164215,255.140045 324.910767,255.140045 334.524872,255.140045 
	C334.524872,249.775238 334.524872,244.871750 334.524872,239.871399 
	C316.921021,239.871399 299.638702,239.871399 282.039581,239.871399 
	C282.039581,248.218033 282.039581,256.359009 282.039581,265.500000 
M65.697723,293.913574 
	C66.792130,295.276764 67.830322,297.762024 68.990120,297.820129 
	C76.231400,298.182892 83.499847,298.003143 91.308548,298.003143 
	C83.595154,278.870483 76.145004,260.266693 68.495758,241.745132 
	C68.066040,240.704651 66.012695,239.793320 64.687889,239.754761 
	C57.869690,239.556259 51.034054,239.864883 44.222294,239.576370 
	C40.881874,239.434891 39.264011,240.435425 37.993336,243.605286 
	C31.202761,260.545258 24.146217,277.378540 17.203987,294.257904 
	C16.742760,295.379333 16.466396,296.576813 16.078512,297.820801 
	C24.280926,297.820801 32.059612,297.820801 39.917862,297.820801 
	C40.970718,294.889526 41.975185,292.092957 43.069984,289.044922 
	C48.790707,289.044922 54.436066,289.269318 60.052113,288.960510 
	C63.405514,288.776123 65.008537,289.952026 65.697723,293.913574 
M273.998993,272.500000 
	C273.998993,261.592010 273.998993,250.684006 273.998993,239.922424 
	C265.915680,239.922424 258.484589,239.922424 250.894989,239.922424 
	C250.894989,259.342987 250.894989,278.514679 250.894989,297.697266 
	C258.714905,297.697266 266.265564,297.697266 273.998993,297.697266 
	C273.998993,289.431000 273.998993,281.465515 273.998993,272.500000 
M134.888351,338.513489 
	C134.888351,334.250183 134.888351,329.986847 134.888351,325.552063 
	C130.650162,325.552063 127.030769,325.552063 123.153900,325.552063 
	C121.025818,333.651154 118.898087,341.748871 116.373528,351.356842 
	C113.846092,341.760712 111.710640,333.652893 109.617775,325.706757 
	C105.447891,325.706757 101.718246,325.706757 97.955048,325.706757 
	C97.955048,336.961426 97.955048,347.866150 97.955048,358.771606 
	C100.480728,358.771606 102.738426,358.771606 105.196625,358.771606 
	C105.196625,351.572449 105.196625,344.617279 105.196625,337.662109 
	C105.418350,337.611511 105.640083,337.560913 105.861809,337.510315 
	C108.012978,344.703491 110.164146,351.896637 112.217201,358.761719 
	C115.288162,358.761719 117.730209,358.761719 120.294785,358.761719 
	C122.303787,351.814606 124.256180,345.063293 126.208572,338.311951 
	C126.505264,338.360016 126.801949,338.408112 127.098633,338.456177 
	C127.098633,345.160278 127.098633,351.864410 127.098633,358.713562 
	C129.870499,358.713562 132.241287,358.713562 134.888351,358.713562 
	C134.888351,352.111420 134.888351,345.809723 134.888351,338.513489 
M215.971481,332.890747 
	C215.290344,328.915253 212.651962,326.534332 208.954208,326.142456 
	C202.587875,325.467773 196.154556,325.425446 189.551056,325.108215 
	C189.551056,336.867310 189.551056,347.763611 189.551056,358.841675 
	C192.060150,358.841675 194.321091,358.841675 197.067825,358.841675 
	C197.067825,354.489990 197.067825,350.248932 197.067825,346.342407 
	C209.321564,343.132690 205.900894,353.917969 208.923172,358.875244 
	C211.518539,358.875244 213.988403,358.875244 216.352219,358.875244 
	C215.730423,356.013580 215.337204,353.211975 214.485153,350.557648 
	C213.609390,347.829437 212.285721,345.244995 211.686905,343.839203 
	C213.282867,340.109894 214.655258,336.903046 215.971481,332.890747 
M175.202484,353.626831 
	C176.381546,350.223358 178.206314,346.894897 178.612030,343.401611 
	C179.612503,334.787476 174.985931,327.886139 167.421570,325.599365 
	C159.385117,323.169952 151.021088,326.071045 147.352310,332.560486 
	C143.050903,340.168945 144.841965,351.374481 151.141052,356.264221 
	C157.965302,361.561615 167.827103,360.715057 175.202484,353.626831 
M226.701248,330.835266 
	C226.701248,340.126801 226.701248,349.418304 226.701248,358.731262 
	C235.145020,358.731262 243.210266,358.731262 251.284164,358.731262 
	C251.284164,356.711334 251.284164,354.980957 251.284164,352.778442 
	C245.445511,352.778442 239.906113,352.778442 234.407806,352.778442 
	C234.407806,350.008087 234.407806,347.716919 234.407806,344.952820 
	C239.678528,344.952820 244.760468,344.952820 250.049805,344.952820 
	C249.920883,342.736572 249.820465,341.010193 249.701141,338.958801 
	C244.278793,338.958801 239.334137,338.958801 234.509583,338.958801 
	C234.509583,336.334229 234.509583,334.073059 234.509583,331.230743 
	C240.143555,331.230743 245.506470,331.230743 250.854279,331.230743 
	C250.854279,329.019897 250.854279,327.400360 250.854279,325.572510 
	C242.887192,325.572510 235.109848,325.572510 226.936676,325.572510 
	C226.857956,327.026581 226.779617,328.473969 226.701248,330.835266 
M275.921600,327.824188 
	C275.921600,338.084259 275.921600,348.344330 275.921600,358.764038 
	C284.403687,358.764038 292.457306,358.764038 300.601624,358.764038 
	C300.601624,356.784973 300.601624,355.064850 300.601624,352.802002 
	C294.803528,352.802002 289.265106,352.802002 283.885681,352.802002 
	C283.885681,349.993439 283.885681,347.736206 283.885681,345.017242 
	C289.090729,345.017242 294.003662,345.017242 299.187012,345.017242 
	C299.065704,342.807861 298.971069,341.085083 298.850739,338.893616 
	C293.519318,338.893616 288.614044,338.893616 283.947693,338.893616 
	C283.947693,336.119263 283.947693,333.864838 283.947693,331.170532 
	C289.550201,331.170532 294.793823,331.170532 300.303802,331.170532 
	C300.191040,328.959137 300.101868,327.210449 300.007111,325.352112 
	C292.685516,325.352112 285.872589,325.286957 279.063568,325.420807 
	C278.014954,325.441406 276.984253,326.376923 275.921600,327.824188 
M339.816193,358.961700 
	C340.085114,358.649719 340.648560,358.235077 340.580719,358.040497 
	C336.979492,347.712555 333.464325,337.348663 329.481842,327.167847 
	C329.035156,326.025940 325.912537,325.492523 324.026611,325.482605 
	C322.343842,325.473694 319.571777,326.154846 319.137787,327.260498 
	C315.091095,337.570526 311.445465,348.037964 307.584534,358.734375 
	C310.628510,358.734375 313.183746,358.734375 315.674164,358.734375 
	C316.346100,356.730713 317.190948,355.040802 317.454834,353.264557 
	C318.164398,348.487793 321.724854,349.710632 324.702362,349.541412 
	C327.644867,349.374146 330.493713,349.321991 330.877716,353.269012 
	C331.372345,358.352356 334.354828,359.825348 339.816193,358.961700 
M367.989227,335.508545 
	C369.866547,335.508545 371.743835,335.508545 373.839630,335.508545 
	C371.062836,325.122894 360.119659,321.427124 352.400543,327.459137 
	C347.216064,331.510498 347.546478,339.292297 353.281647,342.566345 
	C355.828735,344.020416 358.982727,344.397614 361.568573,345.802368 
	C363.385651,346.789490 364.921509,348.543457 366.091431,350.285095 
	C366.359863,350.684662 364.629547,353.374084 363.785980,353.391357 
	C361.483124,353.438477 357.933655,353.383423 357.078522,352.004364 
	C354.470367,347.798126 351.182465,348.940002 347.717377,349.234802 
	C347.807617,358.335693 358.937408,361.144989 366.230804,359.048492 
	C370.732452,357.754425 373.977386,355.248108 374.314331,350.159119 
	C374.649963,345.089447 371.890839,342.047028 367.506226,340.288818 
	C365.052063,339.304718 362.289459,338.987183 359.988434,337.762970 
	C358.639435,337.045258 357.576355,335.247772 357.083679,333.711792 
	C356.866180,333.033875 358.288391,331.083405 359.135468,330.969513 
	C360.782410,330.748108 362.758118,331.034485 364.203064,331.828491 
	C365.480591,332.530457 366.222076,334.207977 367.989227,335.508545 
M403.265320,326.579407 
	C401.241180,330.629181 399.217010,334.678986 396.888214,339.338287 
	C395.147980,336.010315 393.631348,333.763184 392.749268,331.289764 
	C390.800629,325.825562 387.329926,323.925690 381.514465,325.961639 
	C386.221954,336.606354 396.203339,345.376648 392.477020,358.781555 
	C395.592651,358.781555 397.826691,358.781555 400.909576,358.781555 
	C397.107758,345.247009 407.199768,336.468079 412.077728,325.076019 
	C408.864685,325.431885 406.322632,325.713409 403.265320,326.579407 
z"
        />
        <path
          fill="#043248"
          opacity="1.000000"
          stroke="none"
          d="
M464.031281,126.316452 
	C462.889252,128.762405 462.016449,131.131088 460.425629,132.825806 
	C457.810913,135.611359 457.122681,138.436432 458.630707,141.899628 
	C459.558350,144.030060 460.570648,146.149216 461.225739,148.367691 
	C462.827454,153.791748 466.279602,156.330261 471.954498,155.841446 
	C476.263336,155.470276 478.027893,157.751038 478.003632,161.813248 
	C477.993652,163.478561 478.003265,165.143997 478.002625,166.809372 
	C477.999268,175.568604 477.971100,175.597458 469.227661,176.174713 
	C468.565094,176.218445 467.879456,176.195267 467.246613,176.362396 
	C460.545502,178.132278 455.959961,194.056290 460.687622,199.087326 
	C465.443420,204.148315 465.429413,205.173019 460.533234,210.088684 
	C459.828125,210.796570 459.116577,211.498032 458.410034,212.204529 
	C452.104950,218.509354 452.106079,218.508362 445.357666,212.811676 
	C444.850739,212.383682 444.361572,211.905411 443.787292,211.590881 
	C437.790039,208.306152 423.356781,216.522919 423.169983,223.311584 
	C422.983124,230.102722 422.089661,230.968796 415.223389,231.001724 
	C413.724579,231.008911 412.225677,231.007416 410.726868,231.001999 
	C403.803833,230.976929 403.041046,230.323456 402.861633,223.371307 
	C402.755096,219.243332 401.093842,216.420731 397.135803,214.975983 
	C394.798218,214.122711 392.487396,213.168335 390.241089,212.098694 
	C385.967102,210.063492 382.455963,210.543564 379.080536,214.207489 
	C375.187408,218.433395 373.429565,218.207458 369.199829,214.044830 
	C368.250305,213.110367 367.311096,212.165359 366.369415,211.222931 
	C360.256317,205.105225 360.258453,205.106644 365.927063,198.425949 
	C366.354401,197.922363 366.788940,197.407333 367.113739,196.837036 
	C370.563477,190.780014 362.591278,176.413269 355.658020,176.170059 
	C348.755524,175.927933 348.012482,175.160034 347.997681,168.245941 
	C347.994476,166.747101 347.995544,165.248260 347.997559,163.749420 
	C348.007416,156.494720 348.328125,156.055222 355.500946,155.869003 
	C359.662689,155.760956 362.422363,154.003143 363.899261,150.109421 
	C364.841125,147.626236 365.797760,145.137100 366.948486,142.747253 
	C368.972504,138.543808 368.033966,135.215027 364.706635,132.032486 
	C360.587524,128.092636 360.734680,126.222015 364.750336,122.088440 
	C365.678528,121.132988 366.636200,120.206184 367.578308,119.264229 
	C373.646057,113.197617 374.155518,113.184425 380.492737,118.861801 
	C381.108093,119.413109 381.712585,120.031998 382.433960,120.400780 
	C388.260681,123.379364 402.501404,115.142502 402.828125,108.635269 
	C403.192261,101.383026 403.572357,101.009514 410.614777,100.997665 
	C412.446686,100.994583 414.278687,100.986710 416.110535,100.999130 
	C422.022217,101.039215 423.209076,102.020950 423.104950,107.977257 
	C423.023987,112.607353 424.710297,115.596382 429.193298,117.042595 
	C431.396149,117.753242 433.540558,118.705154 435.615082,119.740883 
	C439.898834,121.879608 443.413696,121.275833 446.791107,117.695763 
	C450.745422,113.504181 452.513214,113.643097 456.658661,117.858002 
	C459.204498,120.446487 461.545166,123.236771 464.031281,126.316452 
M438.441803,173.744492 
	C443.744385,156.260468 430.781555,139.370224 412.983093,139.184586 
	C399.375610,139.042648 388.052917,149.344452 386.268829,163.291733 
	C384.672424,175.771393 393.798431,188.770706 406.297180,191.820633 
	C420.067078,195.180725 433.035370,188.120956 438.441803,173.744492 
z"
        />
        <path
          fill="#040404"
          opacity="1.000000"
          stroke="none"
          d="
M114.294373,297.903076 
	C88.306168,289.577271 89.416466,258.664673 103.226212,246.912537 
	C115.975372,236.062958 140.931595,234.679840 153.968246,245.191635 
	C157.733307,248.227509 160.205688,252.866547 163.270691,256.770599 
	C162.909164,257.264740 162.547638,257.758881 162.186111,258.253021 
	C155.520584,259.343658 148.862610,260.487030 142.177902,261.443512 
	C141.508316,261.539337 140.562943,260.611450 139.937668,259.971069 
	C134.591675,254.496216 126.418198,253.953598 121.201851,258.777496 
	C116.124565,263.472809 115.622902,272.609619 120.154602,277.850555 
	C125.091415,283.559998 137.129059,284.846710 143.087677,280.191315 
	C144.290207,279.251801 145.124481,277.840973 146.875336,275.759644 
	C142.255646,275.759644 138.832260,275.759613 135.408875,275.759613 
	C131.933411,275.759613 128.457947,275.759644 124.628754,275.759644 
	C124.628754,271.893707 124.628754,268.320099 124.628754,264.350525 
	C139.123276,264.350525 153.790146,264.350525 168.660568,264.350525 
	C168.660568,275.383240 168.660568,286.317108 168.660568,297.629181 
	C163.014465,297.629181 157.307022,297.629181 151.414398,297.629181 
	C150.933929,294.894409 150.451477,292.148407 149.875015,288.867218 
	C140.012253,299.878143 127.826996,300.891724 114.294373,297.903076 
z"
        />
        <path
          fill="#040404"
          opacity="1.000000"
          stroke="none"
          d="
M382.827118,293.146606 
	C381.282837,290.762817 379.756470,288.741150 378.752716,286.486816 
	C376.134918,280.607574 371.737366,278.391510 365.135498,279.540009 
	C365.135498,285.383026 365.135498,291.313293 365.135498,297.624115 
	C357.082520,297.624115 349.396637,297.624115 341.473236,297.624115 
	C341.473236,278.493530 341.473236,259.412292 341.473236,240.048965 
	C342.529114,239.923660 343.638916,239.673752 344.747650,239.678284 
	C359.056183,239.736649 373.371185,239.595459 387.670746,239.997147 
	C397.690186,240.278595 404.848694,245.481537 406.959930,253.010956 
	C409.797577,263.131012 405.992554,269.971893 393.854126,275.545013 
	C400.007294,277.826416 398.708008,288.822479 408.388733,286.205566 
	C408.542847,286.390961 408.840759,286.603394 408.935181,286.884247 
	C412.109741,296.325104 411.258667,297.655701 401.230957,299.007172 
	C394.315094,299.939270 387.916016,299.209930 382.827118,293.146606 
M370.542755,254.118774 
	C368.775848,254.118774 367.008942,254.118774 365.148346,254.118774 
	C365.148346,258.323792 365.148346,262.018738 365.148346,265.833160 
	C369.854431,265.833160 374.302368,266.058655 378.713959,265.755096 
	C381.733612,265.547302 383.981873,263.898804 384.144745,260.425079 
	C384.318176,256.726318 382.218658,254.909058 378.894806,254.441757 
	C376.457520,254.099091 373.956451,254.210022 370.542755,254.118774 
z"
        />
        <path
          fill="#010101"
          opacity="1.000000"
          stroke="none"
          d="
M214.312927,288.628906 
	C211.566269,281.962402 207.560745,277.924408 199.465927,279.651703 
	C199.465927,285.491028 199.465927,291.531799 199.465927,297.778381 
	C191.460495,297.778381 184.024521,297.778381 176.235748,297.778381 
	C176.235748,278.672485 176.235748,259.481537 176.235748,239.669678 
	C180.049683,239.669678 183.970108,239.647919 187.890228,239.673782 
	C199.373703,239.749512 210.871979,239.509262 222.336517,240.019943 
	C235.387039,240.601242 242.760712,248.419418 242.132233,260.090790 
	C241.765182,266.906982 238.554993,270.633545 228.431076,275.629486 
	C234.540421,277.760925 233.204163,288.889740 243.128204,286.140533 
	C244.061371,289.070282 245.000290,292.018127 245.918915,294.902222 
	C234.885056,302.912445 221.625595,300.324371 214.312927,288.628906 
M203.662445,266.009705 
	C206.651764,265.977997 209.649612,266.076569 212.628189,265.881012 
	C216.204941,265.646210 218.724976,263.855316 218.744156,260.031311 
	C218.762192,256.433075 216.341202,254.551254 213.008240,254.356552 
	C208.586884,254.098251 204.139069,254.292847 199.204391,254.292847 
	C199.204391,257.352478 199.390671,260.146698 199.153519,262.904480 
	C198.901932,265.829987 200.403503,266.276031 203.662445,266.009705 
z"
        />
        <path
          fill="#030303"
          opacity="1.000000"
          stroke="none"
          d="
M474.852081,275.907776 
	C468.947937,280.345947 462.425110,281.249634 455.675995,281.286774 
	C450.544250,281.315002 445.412231,281.292389 439.799744,281.292389 
	C439.799744,286.904877 439.799744,292.141754 439.799744,297.686157 
	C431.760498,297.686157 424.201935,297.686157 416.339478,297.686157 
	C416.339478,278.560059 416.339478,259.336121 416.339478,240.131271 
	C431.904724,240.131271 447.541016,239.602112 463.116272,240.347427 
	C471.292999,240.738693 478.055511,245.266159 480.591095,253.776932 
	C483.041260,262.001099 481.817261,269.592896 474.852081,275.907776 
M444.458191,267.122772 
	C447.109833,267.044403 449.805084,267.237549 452.402313,266.820465 
	C455.812775,266.272797 458.131165,264.379059 458.155487,260.501801 
	C458.179840,256.617218 455.898346,254.523010 452.466827,254.189011 
	C448.257782,253.779327 443.978455,254.091324 439.855591,254.091324 
	C439.855591,258.593140 439.855591,262.676666 439.855591,267.122742 
	C441.226929,267.122742 442.354553,267.122742 444.458191,267.122772 
z"
        />
        <path
          fill="#030303"
          opacity="1.000000"
          stroke="none"
          d="
M282.039581,265.000000 
	C282.039581,256.359009 282.039581,248.218033 282.039581,239.871399 
	C299.638702,239.871399 316.921021,239.871399 334.524872,239.871399 
	C334.524872,244.871750 334.524872,249.775238 334.524872,255.140045 
	C324.910767,255.140045 315.164215,255.140045 305.128876,255.140045 
	C305.128876,257.491241 305.128876,259.388916 305.128876,261.748993 
	C313.919373,261.748993 322.509460,261.748993 331.316376,261.748993 
	C331.316376,266.304565 331.316376,270.404816 331.316376,274.900818 
	C322.590637,274.900818 314.004517,274.900818 305.128967,274.900818 
	C305.128967,277.346924 305.128967,279.423584 305.128967,282.052429 
	C315.038116,282.052429 325.093811,282.052429 335.390442,282.052429 
	C335.390442,287.521606 335.390442,292.449341 335.390442,297.692688 
	C317.764252,297.692688 300.199158,297.692688 282.039581,297.692688 
	C282.039581,287.022644 282.039581,276.261322 282.039581,265.000000 
z"
        />
        <path
          fill="#030303"
          opacity="1.000000"
          stroke="none"
          d="
M65.524597,293.533783 
	C65.008537,289.952026 63.405514,288.776123 60.052113,288.960510 
	C54.436066,289.269318 48.790707,289.044922 43.069984,289.044922 
	C41.975185,292.092957 40.970718,294.889526 39.917862,297.820801 
	C32.059612,297.820801 24.280926,297.820801 16.078512,297.820801 
	C16.466396,296.576813 16.742760,295.379333 17.203987,294.257904 
	C24.146217,277.378540 31.202761,260.545258 37.993336,243.605286 
	C39.264011,240.435425 40.881874,239.434891 44.222294,239.576370 
	C51.034054,239.864883 57.869690,239.556259 64.687889,239.754761 
	C66.012695,239.793320 68.066040,240.704651 68.495758,241.745132 
	C76.145004,260.266693 83.595154,278.870483 91.308548,298.003143 
	C83.499847,298.003143 76.231400,298.182892 68.990120,297.820129 
	C67.830322,297.762024 66.792130,295.276764 65.524597,293.533783 
M52.828568,256.952942 
	C50.811478,262.869537 48.794392,268.786133 46.692478,274.951538 
	C51.406521,274.951538 55.616867,274.951538 60.250065,274.951538 
	C58.506382,269.718567 56.955021,264.848450 55.234890,260.038696 
	C54.755249,258.697510 53.776733,257.534698 52.828568,256.952942 
z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
M273.998993,273.000000 
	C273.998993,281.465515 273.998993,289.431000 273.998993,297.697266 
	C266.265564,297.697266 258.714905,297.697266 250.894989,297.697266 
	C250.894989,278.514679 250.894989,259.342987 250.894989,239.922424 
	C258.484589,239.922424 265.915680,239.922424 273.998993,239.922424 
	C273.998993,250.684006 273.998993,261.592010 273.998993,273.000000 
z"
        />
        <path
          fill="#0A0A0A"
          opacity="1.000000"
          stroke="none"
          d="
M134.888351,339.010742 
	C134.888351,345.809723 134.888351,352.111420 134.888351,358.713562 
	C132.241287,358.713562 129.870499,358.713562 127.098633,358.713562 
	C127.098633,351.864410 127.098633,345.160278 127.098633,338.456177 
	C126.801949,338.408112 126.505264,338.360016 126.208572,338.311951 
	C124.256180,345.063293 122.303787,351.814606 120.294785,358.761719 
	C117.730209,358.761719 115.288162,358.761719 112.217201,358.761719 
	C110.164146,351.896637 108.012978,344.703491 105.861809,337.510315 
	C105.640083,337.560913 105.418350,337.611511 105.196625,337.662109 
	C105.196625,344.617279 105.196625,351.572449 105.196625,358.771606 
	C102.738426,358.771606 100.480728,358.771606 97.955048,358.771606 
	C97.955048,347.866150 97.955048,336.961426 97.955048,325.706757 
	C101.718246,325.706757 105.447891,325.706757 109.617775,325.706757 
	C111.710640,333.652893 113.846092,341.760712 116.373528,351.356842 
	C118.898087,341.748871 121.025818,333.651154 123.153900,325.552063 
	C127.030769,325.552063 130.650162,325.552063 134.888351,325.552063 
	C134.888351,329.986847 134.888351,334.250183 134.888351,339.010742 
z"
        />
        <path
          fill="#0D0D0D"
          opacity="1.000000"
          stroke="none"
          d="
M215.999573,333.293457 
	C214.655258,336.903046 213.282867,340.109894 211.686905,343.839203 
	C212.285721,345.244995 213.609390,347.829437 214.485153,350.557648 
	C215.337204,353.211975 215.730423,356.013580 216.352219,358.875244 
	C213.988403,358.875244 211.518539,358.875244 208.923172,358.875244 
	C205.900894,353.917969 209.321564,343.132690 197.067825,346.342407 
	C197.067825,350.248932 197.067825,354.489990 197.067825,358.841675 
	C194.321091,358.841675 192.060150,358.841675 189.551056,358.841675 
	C189.551056,347.763611 189.551056,336.867310 189.551056,325.108215 
	C196.154556,325.425446 202.587875,325.467773 208.954208,326.142456 
	C212.651962,326.534332 215.290344,328.915253 215.999573,333.293457 
M197.013687,335.636017 
	C197.084763,337.079651 197.155838,338.523315 197.232864,340.087860 
	C199.533432,340.087860 201.512253,340.173248 203.480820,340.067719 
	C206.400711,339.911163 208.251968,338.472198 207.983246,335.354401 
	C207.643600,331.413971 204.459335,331.490601 201.660110,331.318695 
	C199.274307,331.172180 196.270508,330.473328 197.013687,335.636017 
z"
        />
        <path
          fill="#0A0A0A"
          opacity="1.000000"
          stroke="none"
          d="
M174.995117,353.930573 
	C167.827103,360.715057 157.965302,361.561615 151.141052,356.264221 
	C144.841965,351.374481 143.050903,340.168945 147.352310,332.560486 
	C151.021088,326.071045 159.385117,323.169952 167.421570,325.599365 
	C174.985931,327.886139 179.612503,334.787476 178.612030,343.401611 
	C178.206314,346.894897 176.381546,350.223358 174.995117,353.930573 
M154.158768,348.976898 
	C156.131134,352.877319 159.322083,354.621521 163.596268,353.833160 
	C168.002487,353.020447 170.059814,349.709534 170.461578,345.660950 
	C170.766327,342.589874 170.550018,339.324860 169.817673,336.329010 
	C168.898849,332.570251 165.980682,330.503235 162.063858,330.452759 
	C158.195724,330.402924 154.847504,332.167084 154.144852,335.995209 
	C153.419983,339.944397 153.945740,344.123138 154.158768,348.976898 
z"
        />
        <path
          fill="#090909"
          opacity="1.000000"
          stroke="none"
          d="
M226.701263,330.378296 
	C226.779617,328.473969 226.857956,327.026581 226.936676,325.572510 
	C235.109848,325.572510 242.887192,325.572510 250.854279,325.572510 
	C250.854279,327.400360 250.854279,329.019897 250.854279,331.230743 
	C245.506470,331.230743 240.143555,331.230743 234.509583,331.230743 
	C234.509583,334.073059 234.509583,336.334229 234.509583,338.958801 
	C239.334137,338.958801 244.278793,338.958801 249.701141,338.958801 
	C249.820465,341.010193 249.920883,342.736572 250.049805,344.952820 
	C244.760468,344.952820 239.678528,344.952820 234.407806,344.952820 
	C234.407806,347.716919 234.407806,350.008087 234.407806,352.778442 
	C239.906113,352.778442 245.445511,352.778442 251.284164,352.778442 
	C251.284164,354.980957 251.284164,356.711334 251.284164,358.731262 
	C243.210266,358.731262 235.145020,358.731262 226.701248,358.731262 
	C226.701248,349.418304 226.701248,340.126801 226.701263,330.378296 
z"
        />
        <path
          fill="#0D394F"
          opacity="1.000000"
          stroke="none"
          d="
M275.933441,327.356750 
	C276.984253,326.376923 278.014954,325.441406 279.063568,325.420807 
	C285.872589,325.286957 292.685516,325.352112 300.007111,325.352112 
	C300.101868,327.210449 300.191040,328.959137 300.303802,331.170532 
	C294.793823,331.170532 289.550201,331.170532 283.947693,331.170532 
	C283.947693,333.864838 283.947693,336.119263 283.947693,338.893616 
	C288.614044,338.893616 293.519318,338.893616 298.850739,338.893616 
	C298.971069,341.085083 299.065704,342.807861 299.187012,345.017242 
	C294.003662,345.017242 289.090729,345.017242 283.885681,345.017242 
	C283.885681,347.736206 283.885681,349.993439 283.885681,352.802002 
	C289.265106,352.802002 294.803528,352.802002 300.601624,352.802002 
	C300.601624,355.064850 300.601624,356.784973 300.601624,358.764038 
	C292.457306,358.764038 284.403687,358.764038 275.921600,358.764038 
	C275.921600,348.344330 275.921600,338.084259 275.933441,327.356750 
z"
        />
        <path
          fill="#0C384F"
          opacity="1.000000"
          stroke="none"
          d="
M339.402710,358.987671 
	C334.354828,359.825348 331.372345,358.352356 330.877716,353.269012 
	C330.493713,349.321991 327.644867,349.374146 324.702362,349.541412 
	C321.724854,349.710632 318.164398,348.487793 317.454834,353.264557 
	C317.190948,355.040802 316.346100,356.730713 315.674164,358.734375 
	C313.183746,358.734375 310.628510,358.734375 307.584534,358.734375 
	C311.445465,348.037964 315.091095,337.570526 319.137787,327.260498 
	C319.571777,326.154846 322.343842,325.473694 324.026611,325.482605 
	C325.912537,325.492523 329.035156,326.025940 329.481842,327.167847 
	C333.464325,337.348663 336.979492,347.712555 340.580719,358.040497 
	C340.648560,358.235077 340.085114,358.649719 339.402710,358.987671 
M323.158966,334.980621 
	C322.375061,337.716125 321.591156,340.451599 320.736359,343.434448 
	C323.381134,343.434448 325.292847,343.434448 327.731476,343.434448 
	C326.678558,339.969543 325.735413,336.865936 324.792297,333.762299 
	C324.344238,333.939209 323.896149,334.116150 323.158966,334.980621 
z"
        />
        <path
          fill="#0B374D"
          opacity="1.000000"
          stroke="none"
          d="
M367.594727,335.481659 
	C366.222076,334.207977 365.480591,332.530457 364.203064,331.828491 
	C362.758118,331.034485 360.782410,330.748108 359.135468,330.969513 
	C358.288391,331.083405 356.866180,333.033875 357.083679,333.711792 
	C357.576355,335.247772 358.639435,337.045258 359.988434,337.762970 
	C362.289459,338.987183 365.052063,339.304718 367.506226,340.288818 
	C371.890839,342.047028 374.649963,345.089447 374.314331,350.159119 
	C373.977386,355.248108 370.732452,357.754425 366.230804,359.048492 
	C358.937408,361.144989 347.807617,358.335693 347.717377,349.234802 
	C351.182465,348.940002 354.470367,347.798126 357.078522,352.004364 
	C357.933655,353.383423 361.483124,353.438477 363.785980,353.391357 
	C364.629547,353.374084 366.359863,350.684662 366.091431,350.285095 
	C364.921509,348.543457 363.385651,346.789490 361.568573,345.802368 
	C358.982727,344.397614 355.828735,344.020416 353.281647,342.566345 
	C347.546478,339.292297 347.216064,331.510498 352.400543,327.459137 
	C360.119659,321.427124 371.062836,325.122894 373.839630,335.508545 
	C371.743835,335.508545 369.866547,335.508545 367.594727,335.481659 
z"
        />
        <path
          fill="#0D394F"
          opacity="1.000000"
          stroke="none"
          d="
M403.522949,326.287170 
	C406.322632,325.713409 408.864685,325.431885 412.077728,325.076019 
	C407.199768,336.468079 397.107758,345.247009 400.909576,358.781555 
	C397.826691,358.781555 395.592651,358.781555 392.477020,358.781555 
	C396.203339,345.376648 386.221954,336.606354 381.514465,325.961639 
	C387.329926,323.925690 390.800629,325.825562 392.749268,331.289764 
	C393.631348,333.763184 395.147980,336.010315 396.888214,339.338287 
	C399.217010,334.678986 401.241180,330.629181 403.522949,326.287170 
z"
        />
        <path
          fill="#FDFDFD"
          opacity="1.000000"
          stroke="none"
          d="
M438.291901,174.114624 
	C433.035370,188.120956 420.067078,195.180725 406.297180,191.820633 
	C393.798431,188.770706 384.672424,175.771393 386.268829,163.291733 
	C388.052917,149.344452 399.375610,139.042648 412.983093,139.184586 
	C430.781555,139.370224 443.744385,156.260468 438.291901,174.114624 
z"
        />
        <path
          fill="#F9F9F9"
          opacity="1.000000"
          stroke="none"
          d="
M371.013306,254.118774 
	C373.956451,254.210022 376.457520,254.099091 378.894806,254.441757 
	C382.218658,254.909058 384.318176,256.726318 384.144745,260.425079 
	C383.981873,263.898804 381.733612,265.547302 378.713959,265.755096 
	C374.302368,266.058655 369.854431,265.833160 365.148346,265.833160 
	C365.148346,262.018738 365.148346,258.323792 365.148346,254.118774 
	C367.008942,254.118774 368.775848,254.118774 371.013306,254.118774 
z"
        />
        <path
          fill="#F2F2F2"
          opacity="1.000000"
          stroke="none"
          d="
M203.192215,266.009705 
	C200.403503,266.276031 198.901932,265.829987 199.153519,262.904480 
	C199.390671,260.146698 199.204391,257.352478 199.204391,254.292847 
	C204.139069,254.292847 208.586884,254.098251 213.008240,254.356552 
	C216.341202,254.551254 218.762192,256.433075 218.744156,260.031311 
	C218.724976,263.855316 216.204941,265.646210 212.628189,265.881012 
	C209.649612,266.076569 206.651764,265.977997 203.192215,266.009705 
z"
        />
        <path
          fill="#FCFCFC"
          opacity="1.000000"
          stroke="none"
          d="
M443.970154,267.122742 
	C442.354553,267.122742 441.226929,267.122742 439.855591,267.122742 
	C439.855591,262.676666 439.855591,258.593140 439.855591,254.091324 
	C443.978455,254.091324 448.257782,253.779327 452.466827,254.189011 
	C455.898346,254.523010 458.179840,256.617218 458.155487,260.501801 
	C458.131165,264.379059 455.812775,266.272797 452.402313,266.820465 
	C449.805084,267.237549 447.109833,267.044403 443.970154,267.122742 
z"
        />
        <path
          fill="#F9F9F9"
          opacity="1.000000"
          stroke="none"
          d="
M52.927818,256.621521 
	C53.776733,257.534698 54.755249,258.697510 55.234890,260.038696 
	C56.955021,264.848450 58.506382,269.718567 60.250065,274.951538 
	C55.616867,274.951538 51.406521,274.951538 46.692478,274.951538 
	C48.794392,268.786133 50.811478,262.869537 52.927818,256.621521 
z"
        />
        <path
          fill="#F2F2F2"
          opacity="1.000000"
          stroke="none"
          d="
M197.013718,335.178864 
	C196.270508,330.473328 199.274307,331.172180 201.660110,331.318695 
	C204.459335,331.490601 207.643600,331.413971 207.983246,335.354401 
	C208.251968,338.472198 206.400711,339.911163 203.480820,340.067719 
	C201.512253,340.173248 199.533432,340.087860 197.232864,340.087860 
	C197.155838,338.523315 197.084763,337.079651 197.013718,335.178864 
z"
        />
        <path
          fill="#F8F8F8"
          opacity="1.000000"
          stroke="none"
          d="
M154.041565,348.589172 
	C153.945740,344.123138 153.419983,339.944397 154.144852,335.995209 
	C154.847504,332.167084 158.195724,330.402924 162.063858,330.452759 
	C165.980682,330.503235 168.898849,332.570251 169.817673,336.329010 
	C170.550018,339.324860 170.766327,342.589874 170.461578,345.660950 
	C170.059814,349.709534 168.002487,353.020447 163.596268,353.833160 
	C159.322083,354.621521 156.131134,352.877319 154.041565,348.589172 
z"
        />
        <path
          fill="#DCE2E5"
          opacity="1.000000"
          stroke="none"
          d="
M323.303528,334.636841 
	C323.896149,334.116150 324.344238,333.939209 324.792297,333.762299 
	C325.735413,336.865936 326.678558,339.969543 327.731476,343.434448 
	C325.292847,343.434448 323.381134,343.434448 320.736359,343.434448 
	C321.591156,340.451599 322.375061,337.716125 323.303528,334.636841 
z"
        />
      </svg>
    </SvgIcon>
  );
};
